import { render, staticRenderFns } from "./pickup-store-card.vue?vue&type=template&id=18f50ca8&"
import script from "./pickup-store-card.vue?vue&type=script&lang=js&"
export * from "./pickup-store-card.vue?vue&type=script&lang=js&"
import style0 from "./pickup-store-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f50ca8')) {
      api.createRecord('18f50ca8', component.options)
    } else {
      api.reload('18f50ca8', component.options)
    }
    module.hot.accept("./pickup-store-card.vue?vue&type=template&id=18f50ca8&", function () {
      api.rerender('18f50ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/pickup-store-card.vue"
export default component.exports